<template>
    <div  >
            <top-navbar></top-navbar>
    
    
            <div  class="mb-5  background_color " >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/issuetracking/index"> {{language[1]['Home']}}  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{language[136]['Dashboard']}} </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">
                <div class="">
                <div class="">


                    <form @submit.prevent="SaveProduct()" >

<div class="row">
 
  
 <div class="col-md-3">
 
          
           <v-select :placeholder="`${language[137]['Select']} ${language[16]['Main Category']}`" @input="subCat"  v-model="all_data.maincat" :options="mainscats"  label="category_name" ></v-select>
  
 </div>

 <div class="col-md-3">
 
         
           <v-select :placeholder="`${language[137]['Select']} ${language[17]['Sub Category']}`"  @input="laodMessage()"  v-model="all_data.subcat" :options="subcats"  label="category_name" :disabled="!all_data.maincat"></v-select>
 
 </div>
 



 
</div>

<div class="row">

 
 <div class="col-md-4">
    <div  class="card bdr-rad2 mt-2 shadow p-2 ">
        <div class="card-body">

            <h4>{{language[141]['Open cases per month']}}</h4>
            <template >
            <div >
                <BarChart style="width: 100%; height: 100%;" :months="months" :values="values" />
            </div>
            </template>

        </div>
    </div>
 </div>
 <div class="col-md-4">
  <div class="card bdr-rad2 mt-2 shadow p-2">
    <div class="card-body "> <!-- Add text-center class -->

      <h4>{{language[141]['Open cases per month']}}</h4>
      <template>
        <div class="chart-container">
          <PieChart style="width: 50%;" :labels="pieLabels" :data="pieData" />
        </div>
      </template>

    </div>
  </div>
</div>

<div class="col-md-4">
   <div  class="card bdr-rad2 mt-2 shadow p-2 ">
       <div class="card-body">

           <h4>{{language[141]['Open cases per month']}}</h4>
           <table  style="font-size: small; " class="table table-sm">
            <thead class="table-light">
              <tr>
                <th>#</th>
                <th>{{language[80]['Contractor']}}</th>
                <th>{{language[142]['Average Time spent']}}</th>
              </tr>
              
            </thead>
            <tbody>
                <tr>
                  <td>1</td>
                  <td>sara</td>
                  <td>10h</td>
                </tr>
               
                <tr>
                  <td>2</td>
                  <td>dervin</td>
                  <td>2d</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>jack2</td>
                  <td>5d</td>
                </tr>
               
                <tr>
                  <td>4</td>
                  <td>atmancon</td>
                  <td>2d</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Total</td>
                  <td>2d</td>
                </tr>
            </tbody>

           </table>
           

       </div>
   </div>
</div>

   

</div>

<div class="row">

 



</div>




















   

    <!-- <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-sm btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[52]['Create']}}</button>
    </div>
    </div> -->
    <br><br>


</form>




                </div>
                </div>
           <br><br>
            </div>
           
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import httpClient from '@/axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
      import BarChart from "../../components/BarChart.vue";
      import PieChart from "../../components/PieChart.vue";
     
    
    
      export default {
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
            BarChart,
            PieChart,
        },


        mounted(){

    this.loadCat();
      },


        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            language:JSON.parse(authService.isLanguage()),
        total:0,
        selectedOption: null, // Store the selected option
        file: null,
        all_data:{},
        errors: {},
        mainscats:[],
      
        subcats:[],
        contractor:{},
        months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      values: Array.from({ length: 12 }, () => Math.floor(Math.random() * 500) + 1),
       
      pieLabels: ["Red", "Blue", "Yellow", "Green", "Purple"], // Labels for the pie chart sections
      pieData: [12, 19, 3, 5, 2],
      
           
          }
    
        },
       
        methods : {

          async subCat() {
    // console.log("aaaaa");
    // console.log(this.issue.maincat);
    if(this.all_data.maincat == null){
        this.all_data.subcat = '';
    } 
    try {
      const { data} = await  httpClient.post('/web/api/issuetracking/loadsub',{userid:this.userid,issue:this.all_data},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       
       this.subcats = data.subcats;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },
          async loadCat() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/issuetracking/loadcat',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mainscats = data.mainscats;
       
      
    } catch (error) {
      console.log(error.response);
    }
  
  },

     

    },
    
    }
    
    </script>

    <style scoped>


.chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Ensure it fills the container height */
}

    </style>
    